import React, { useEffect, useState } from 'react';
import { canBuildCrossword, Crossword, generateGrid, } from '../../utils/crossword';
import { Grid } from './Grid';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowsRotate } from '@fortawesome/free-solid-svg-icons';
export const WordBox = ({ randomiseGrid, words, seed, onUpdate, onCancel, }) => {
    const [isInitialized, setIsInitialized] = useState(false);
    const [validationMessage, setValidationMessage] = useState('');
    const [text, setText] = useState(words
        ? words
            .map((word) => `${word.answer.toUpperCase()} ${word.clue}`)
            .join('\n')
        : '');
    const [updatedWordList, setUpdatedWordList] = useState(words);
    const [hints, setHints] = useState(seed);
    const [grid, setGrid] = useState(null);
    useEffect(() => {
        if (seed) {
            const { newGrid, length, height } = generateGrid(seed);
            setGrid({ cells: newGrid, height, length });
        }
        setIsInitialized(true);
    }, []);
    useEffect(() => {
        if (!updatedWordList || updatedWordList.length === 0) {
            setGrid(null);
        }
        else {
            if (!randomiseGrid) {
                if (isInitialized) {
                    if (canBuildCrossword(updatedWordList.map((w) => w.answer))) {
                        const newCrossword = new Crossword(updatedWordList);
                        newCrossword.generate();
                        newCrossword.generateHints();
                        setHints(newCrossword.hints);
                        const { newGrid, length, height } = generateGrid(newCrossword.hints);
                        setGrid({ cells: newGrid, height, length });
                    }
                }
            }
        }
    }, [updatedWordList?.length]);
    const handleRegenerateGrid = () => {
        if (updatedWordList && updatedWordList.length > 0) {
            if (canBuildCrossword(updatedWordList.map((w) => w.answer))) {
                const newCrossword = new Crossword(updatedWordList);
                newCrossword.generate();
                newCrossword.generateHints();
                setHints(newCrossword.hints);
                const { newGrid, length, height } = generateGrid(newCrossword.hints);
                setGrid({ cells: newGrid, height, length });
            }
        }
    };
    function getWordsFromText(text) {
        const answerList = [];
        const wordList = [];
        const lines = text.trim().replace(/\n+/g, '\n');
        lines.split('\n').forEach((line) => {
            line = line.trim().replace(/\n+/g, '\n');
            const word = line.split(' ');
            if (word.length > 1) {
                answerList.push(word[0]);
                wordList.push({
                    answer: word[0].trim().replace(/\s+/g, ''),
                    clue: line.substring(word[0].length).trim().replace(/\s+/g, ' '),
                });
            }
        });
        return { answerList, wordList };
    }
    const handleTextChange = (e) => {
        setValidationMessage('');
        // const regex1 = /^[a-zA-Z0-9\-,.\s\n]*$/;
        const regex1 = /^[\w\W]*$/;
        if (regex1.test(e.target.value)) {
            setText(e.target.value);
            // const regex2 = /^(([a-zA-Z\s]*:[a-zA-Z0-9\s.,]*(?:\n+|$))+)?$/;
            // const regex2 = /^([a-zA-Z]+)\s+([a-zA-Z0-9 \-,.]+)$/gm;
            const regex2 = /^([a-zA-Z]+)\s+([\w\W]+)$/gm;
            if (regex2.test(e.target.value)) {
                const { answerList, wordList } = getWordsFromText(e.target.value);
                if (canBuildCrossword(answerList)) {
                    setUpdatedWordList(wordList);
                }
            }
        }
        else {
            setValidationMessage('can only use alphabets, numbers, and special characters');
        }
    };
    const handleWordsSubmit = () => {
        if (!text || text == '') {
            setValidationMessage('Cannot be empty');
        }
        else {
            // const regex = /^([a-zA-Z]+)\s+([a-zA-Z0-9 \-,.]+)$/gm;
            const regex = /^([a-zA-Z]+)\s+([\w\W]+)$/gm;
            if (regex.test(text)) {
                const { answerList, wordList } = getWordsFromText(text);
                if (canBuildCrossword(answerList)) {
                    onUpdate(wordList, hints);
                }
                else {
                    setValidationMessage('The given set of words cannot form a crossword!');
                }
            }
            else {
                setValidationMessage('Please enter data in proper format');
            }
        }
    };
    return (React.createElement("div", { className: "word-form__container" },
        React.createElement("p", { className: "validation-message" }, validationMessage),
        React.createElement("div", { className: "word-form__content" },
            React.createElement("textarea", { className: "word-form__textarea", value: text, onChange: handleTextChange, placeholder: 'ANSWER1: Clue1\nANSWER2: Clue2', rows: 10, onFocus: () => setValidationMessage('') }),
            !randomiseGrid && (React.createElement("div", { className: "word-form__grid-controls" },
                React.createElement("button", { className: "btn--primary", onClick: handleRegenerateGrid, title: "Regenerate grid layout" },
                    React.createElement(FontAwesomeIcon, { icon: faArrowsRotate })))),
            !randomiseGrid && grid && (React.createElement("div", { className: "word-form__grid-container" },
                React.createElement(Grid, { cells: grid.cells, height: grid.height, length: grid.length })))),
        React.createElement("div", { className: "word-form__controls" },
            React.createElement("button", { className: "btn--primary", onClick: handleWordsSubmit }, "Submit"),
            React.createElement("button", { className: "btn--secondary", onClick: () => {
                    onCancel();
                } }, "Cancel"))));
};
